import { USER_ACCESS } from "@/constants";
import { useInviteContext } from "@/containers/InviteWizard/InviteContext";
import SearchSubscriptions from "@/containers/SearchSubscriptions";
import Button from "@components/Button";
import Rhythm from "@components/Rhythm";
import Typography from "@components/Typography";
import { useWizard } from "@components/Wizard";

import styles from "../InviteWizard.module.css";
export type SetSearchSubscriptionsProps = { className?: string };

const SetSearchSubscriptions: React.FunctionComponent<
  SetSearchSubscriptionsProps
> = () => {
  const { next } = useWizard();
  const { organizationUuid } = useInviteContext();
  const user = useInviteContext().user!;

  return (
    <>
      <Rhythm>
        <Typography variant="h3" data-testid="user-add-step-2-title">
          {L.ORGANIZATION_INVITE_USER_SEARCH_SUBSCRIPTIONS_TITLE}
        </Typography>
        <Typography>
          {user.user_type === USER_ACCESS.USER
            ? L.ORGANIZATION_INVITE_USER_SEARCH_SUBSCRIPTIONS_SUBTITLE_USER
            : L.ORGANIZATION_INVITE_USER_SEARCH_SUBSCRIPTIONS_SUBTITLE_READONLY}
        </Typography>
      </Rhythm>
      <Rhythm>
        <SearchSubscriptions
          className={styles.longtable}
          userId={user.id}
          organizationUuid={organizationUuid}
        />
      </Rhythm>
      <Rhythm className={styles.actions}>
        <Button onClick={next} data-testid="user-add-step-2-continue">
          {L.ORGANIZATION_INVITE_NEXT_STEP}
        </Button>
      </Rhythm>
    </>
  );
};

export default SetSearchSubscriptions;
